import { PRODUCT_IDS, EntitlementsProject } from '@adsk/alloy-provider';

/**
 * This method returns the project URL based on given project & current product ID
 * @return {string}
 */
export default (project: EntitlementsProject, currentProductId?: string) => {
  const productToLookFor =
    currentProductId === PRODUCT_IDS.ACCOUNT_ADMINISTRATION
      ? PRODUCT_IDS.PROJECT_ADMINISTRATION
      : currentProductId;
  const product = project?.products?.find((p) => p.key === productToLookFor);

  return product?.defaultUrl || project.defaultUrl;
};
